var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "register-container" }, [
    _c("h2", { staticClass: "text-center m-b-md" }, [
      _vm.isSuccess
        ? _c("span", [_vm._v("出金依頼が完了しました。")])
        : _c("span", [_vm._v("出金依頼が失敗しました。")])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "announce-container text-center" },
      [
        _vm.isSuccess
          ? [
              _c("span", [_vm._v("出金依頼ありがとうございました。")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _c("span", [_vm._v("7営業日以内に")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v("ご指定の方法でお支払いさせていただきます。")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("お手続きまで今しばらくお待ちください。")])
            ]
          : [
              _c("span", [_vm._v("出金依頼が失敗しました。")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _c("span", [_vm._v("お時間を置いてから")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v("\n        再度\n        "),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.$emit("refreshScreen")
                      }
                    }
                  },
                  [_vm._v("こちら")]
                ),
                _vm._v("\n        から依頼をお願い致します。\n      ")
              ])
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a002aa22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a002aa22","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/revenue/ReqMoneyComplete.vue
// module id = null
// module chunks = 